import React from 'react';
import CustomCountDown from './CustomCountDown';
import './CountdownBanner.css';

const CountdownBanner = () => {
    const timeTillDate = '2023-10-20 00:00 GMT+0200';
    const timeFormat = 'YYYY-MM-DD HH:mm Z';

    return (
        <div
            className="h-fit bg-primary2 w-full
                        xl:w-[1200px] xl:left-[calc(50%-600px)] xl:mb-[2rem]
                        2xl:w-[1500px] 2xl:left-[calc(50%-750px)]
                        "
        >
            <div className="pb-4 px-8 md:pb-6 md:px-12 lg:pb-8 lg:px-16 xl:pt-8 xl:pb-8 xl:px-24">
                <div className="flex flex-wrap xl:flex-nowrap">
                    <div className="w-full text-center xl:text-left">
                        {/* ignore the div below. it was just a dirty quick fix for the spacing... because of the "Registration opens in" section." */}

                        <div className="text-xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold h-12 lg:h-16 xl:h-24 text-center pt-4">
                            <span className="text-primary1">
                                Thanks for joining
                            </span>
                            <span className="text-white"> the Collabothon</span>
                        </div>
                        <div className="hidden md:block text-white text-xs xl:text-base 2xl:text-lg text-center pt-2 xl:pt-4">
                            IN &nbsp;&nbsp; FRANKFURT &nbsp;&nbsp; //
                            &nbsp;&nbsp; LODZ &nbsp;&nbsp; // &nbsp;&nbsp;
                            PRAGUE &nbsp;&nbsp; // &nbsp;&nbsp; SOFIA
                        </div>
                        <div className="block md:hidden text-white text-xs xl:text-base 2xl:text-lg pt-2 md:pt-0">
                            IN &nbsp; FRANKFURT &nbsp; // &nbsp; LODZ &nbsp; //
                            &nbsp; PRAGUE &nbsp; // &nbsp; SOFIA
                        </div>
                    </div>
                    {/*<div className="w-full xl:w-1/2 py-2 md:py-4 lg:py-6 xl:py-0">*/}
                    {/*    <div className="w-full text-xs xl:text-base text-center text-white py-4">*/}
                    {/*        Register now and stay tuned! Collabothon starts in*/}
                    {/*    </div>*/}
                    {/*    <CustomCountDown*/}
                    {/*        timeTillDate={timeTillDate}*/}
                    {/*        timeFormat={timeFormat}*/}
                    {/*    />*/}
                    {/*</div>*/}
                </div>
            </div>
        </div>
    );
};

export default CountdownBanner;
